<template>
  <div class="h-100">
    <vis-toolbar :items="toolbar" class="vis-grid-toolbar" />

    <vis-user-list-view
      :search-nickname="searchNickname"
      :search-email="searchEmail"
      :emailConfirmed="isEmailConfirmed"
      :consentsConfirmed="isConsentsConfirmed"
      @select="onSelect"
      @dblclick="edit"
      :eventBus="eventBus"
      ref="list"
      :grid-class="'vis-has-toolbar'"
    />
    <vis-create-account-form
      v-if="createAccount"
      :visible="createAccount"
      :crud-service="detailView.crudService"
      @hide="() => createAccount = false"
    />

    <vis-detail-view-dialog
      v-if="detailView.crudService !== null"
      :crud-service="detailView.crudService"
      :visible="detailView.visible"
      @hide="() => detailView.visible = false"
      @save="onDetailViewSave"
    />

    <vis-confirm-dialog-ex :dialog="deleteDialog" />
  </div>
</template>
<script>
import RemoteCrudService from "@/shared/services/remote-crud-service";
import VisCreateAccountForm from "@/views/admin/vis-create-account-form";
import gridCommands from "@/views/base/list-view/commands/grid-commands";
import deleteDialog from "../base/list-view/grid/js/dialog/delete";
import api from "@/api/visary-api";
import log from "@/shared/log";
import identityApi from "@/api/identity-api";

export default {
  name: "vis-user-grid-view",
  mixins: [deleteDialog],
  props:{
    eventBus: { type: Object, required: true }
  },
  components: {
    VisCreateAccountForm
  },
  data() {
    var vm = this;
    return {
      searchNickname: "",
      searchEmail: "",
      isEmailConfirmed: null,
      isConsentsConfirmed: null,
      selectedIds: [],
      createAccount: false,
      detailView: {
        crudService: null,
        visible: false
      },
      mnemonic: "AccessUser",
      toolbar: [
        {
          id: "buttons",
          type: "button-group",
          buttons: [
            {
              id: "add",
              icon: "far fa-plus-circle",
              title: vm.$t("add"),
              order: 0,
              onClick() {
                vm.createAccount = true;
              },
              updateState() {
                this.disabled = false;
              }
            },
            {
              id: "edit",
              icon: "far fa-pencil",
              title: vm.$t("edit"),
              disabled: true,
              order: 10,
              onClick: vm.edit,
              updateState() {
                this.disabled = vm.selectedIds.length !== 1;
              }
            },
            {
              id: "lock",
              icon: "far fa-lock",
              title: vm.$t("administration.actions.disableAccount"),
              disabled: true,
              order: 20,
              async onClick() {
                await vm.setAccountsEnabled(false);
              },
              updateState() {
                this.disabled = vm.selectedIds.length == 0;
              }
            },
            {
              id: "unlock",
              icon: "far fa-unlock",
              title: vm.$t("administration.actions.enableAccount"),
              disabled: true,
              order: 20,
              async onClick() {
                await vm.setAccountsEnabled(true);
              },
              updateState() {
                this.disabled = vm.selectedIds.length == 0;
              }
            },
            {
              icon: "fal fa-question",
              type: "vis-mnemonic-help-toolbar-button",
              mnemonic: "UserAdministrationHelpFile",
              title: this.$t("toolbar.button.Help"),
            }
          ]
        },
        {
          id: "search",
          type: "search-input",
          position: "right",
          placeholder: 'Поиск по имени...',
          onUpdate: v => {
            this.searchNickname = v;
          }
        },
        {
          id: "search-email",
          type: "search-input",
          position: "right",
          placeholder: 'Поиск по логину...',
          onUpdate: v => {
            this.searchEmail = v;
          }
        },
        {
          type: "select",
          position: "right",
          selected: null,
          onSelect(val) {
            vm.isConsentsConfirmed = val
          },
          options: [
            {
             value: null,
             text: "Активность профиля",
            },
            {
             value: true,
             text: "Вход выполнялся",
            },
            {
             value: false,
             text: "Вход не выполнялся",
            },
          ]
        },
        {
          type: "select",
          position: "right",
          selected: null,
          onSelect(val) {
            vm.isEmailConfirmed = val
          },
          options: [
            {
             value: null,
             text: "Подтверждение Email",
            },
            {
             value: true,
             text: "Email подтвержден",
            },
            {
             value: false,
             text: "Email не подтвержден",
            },
          ]
        }
      ],
      deleteDialog: {
        acceptChanges: vm.acceptDelete
      },
    };
  },
  methods: {
    async setAccountsEnabled(isEnabled) {
      let items = this.selectedIds.map(x => ({
        id: x,
        model: { Enabled: isEnabled }
      }));

      for (var item of items) {
        await identityApi.admin.setEnabled(item.id, item.model);
      }
      this.eventBus.$emit(gridCommands.refresh);
    },
    add() {
      this.detailView.crudService.setId(0);
      this.detailView.visible = true;
    },
    async edit() {
      let id = this.selectedIds[0];
      this.detailView.crudService.setId(id);
      this.detailView.visible = true;
    },
    async acceptDelete() {
      try {
        await Promise.all(
          this.selectedIds.map(async id => {
            await api.administration.disableUser(id);
          })
        );
      } catch (err) {
        log.error(err);

        this.$visNotification.error(
          this.$t("grid.notifications.couldNotDeleteSelectedRecords")
        );
      } finally {
        this.eventBus.$emit(gridCommands.refresh);
        this.deleteDialog.visible = false;
      }
    },
    onSelect(event) {
      this.selectedIds = event.keys;
      this.updateToolbarState();
    },
    async onDetailViewSave(e) {
      this.detailView.visible = !e.close;
      this.eventBus.$emit(gridCommands.refresh);
    },
    updateToolbarState() {
      this.toolbar.forEach(t => {
        if (t.buttons)
          t.buttons.forEach(b => {
            if (b.updateState) b.updateState();
          });
      });
    },
  },
  created() {
    this.detailView.crudService = new RemoteCrudService(this.mnemonic);
    this.updateToolbarState();
  }
};
</script>
